module.exports = __webpack_public_path__ + "static/media/resume.eeafc3b5.pdf";